import { useEffect } from "react";

const CalendlyBadge = () => {
  useEffect(() => {
    const existingScript = document.getElementById("calendly-widget-script");
    if (existingScript) {
      // Script already loaded, just init badge
      if ((window as any).Calendly) {
        (window as any).Calendly.initBadgeWidget({
          url: "https://calendly.com/arun-amx/30min",
          text: "Schedule time with me",
          color: "#0069ff",
          textColor: "#ffffff",
          branding: true,
        });
      }
      return;
    }

    const script = document.createElement("script");
    script.id = "calendly-widget-script";
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => {
      if ((window as any).Calendly) {
        (window as any).Calendly.initBadgeWidget({
          url: "https://calendly.com/arun-amx/30min",
          text: "Schedule time with me",
          color: "#0069ff",
          textColor: "#ffffff",
          branding: true,
        });
      }
    };

    document.body.appendChild(script);
  }, []);

  return null;
};

export default CalendlyBadge;
